import React from "react";
import { useAuth } from "./AuthContext";

const Home = () => {
  const authUser = useAuth();

  if (authUser) {
    let urlRef = sessionStorage.getItem("app:redirect");
    if (urlRef != null) {
      console.log("Redirecting to " + urlRef);
      sessionStorage.removeItem("app:redirect");
      window.location.href = urlRef;
    }
  }

  return (
    <>
      {authUser &&
        <div className='text-center'>
          <h3>Welcome, {authUser ? authUser.profile.given_name : ""}!</h3>
          <p>You are successfully logged in. If you are not automatically redirected, please reload the page. </p>
          <p>If you keep seeing this even after several reload attempts, please contact support for assistance. </p>
        </div>
      }
    </>
  );
};

export default Home;
